import { Answer, IAnswer } from "./answer.model";

export interface IAnswerItem {
  answerId: string;
  questionId: string;
  answer: string;
  totalVotes: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  answers: IAnswer[];
}

export class AnswerItem {
  answerId: string;
  questionId: string;
  answer: string;
  totalVotes: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  answers: Answer[];

  constructor(data: IAnswerItem) {
    this.answerId = data.answerId;
    this.questionId = data.questionId;
    this.answer = data.answer;
    this.totalVotes = data.totalVotes;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.answers = data.answers
      ? data.answers.map(
          (answer) => new Answer(answer)
        )
      : []
  }
}
